// extracted by mini-css-extract-plugin
export default {"inlineInput":"TbkhudzmNBPKw48zN-dIf"};